export default __webpack_public_path__ + "media/complete-missions.46dbc2b2.png";